type imageOptions = {
   [key:string]: any;
}
const images: imageOptions = {
   castle: require('./images/castle.png'),
   clown: require('./images/clown.png'),
   coffin: require('./images/coffin.png'),
   devil: require('./images/Devil.png'),
   devilEye: require('./images/devilEye.png'),
   dracula: require('./images/dracula.png'),
   draculaBro: require('./images/draculaBro.png'),
   frankenstein: require('./images/frankenstein.png'),
   ghost: require('./images/ghost.png'),
   kettle: require('./images/kettle.png'),
   necromancyBook: require('./images/necromancyBook.png'),
   pentagram: require('./images/pentagram.png'),
   poisonedPotion: require('./images/poisonedPotion.png'),
   pumpkin: require('./images/pumpkin.png'),
   skullWithBones: require('./images/SkullWithBones.png'),
   tomb: require('./images/tomb.png'),
   witchHat: require('./images/witchHat.png'),
   zombie: require('./images/zombie.png'),

   back: require('./images/back.png')
}
export default images;
